import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        emptyState: {
            padding: theme.spacing(3),
        },
    });
});
